import { createGlobalStyle } from "styled-components";
import Variables from "../../assets/styleVariables";

export const GlobalStyle = createGlobalStyle`
    html {
      line-height: 1.15; /* 1 */
      -webkit-text-size-adjust: 100%; /* 2 */
      direction:rtl;
      //min-width: 992px;
    }
    body {
      margin: 0;
      direction: rtl;
      text-align: right;
      font-family: Number, sans-serif;
      //min-width: 992px;
      overflow-y: auto;
    }
    
    * {
    	box-sizing: border-box;
    	scrollbar-color: #9E9E9E #DDDDDD;
	    scrollbar-width: thin;
		outline: none !important;
    }
    
    /* width */
		*::-webkit-scrollbar {
			width: 8px;
			height: 8px;
			background: #DDDDDD;
			border-radius: 4px;
		}
		/* Track */
		*::-webkit-scrollbar-track {
			border-radius: 4px;
		}
		/* Handle */
		*::-webkit-scrollbar-thumb {
			background: #9E9E9E;
			border-radius: 4px;
		}
		/* Handle on hover */
		*::-webkit-scrollbar-thumb:hover {
			background: #9E9E9E;
		}
    
    main {
      display: block;
    }
    
    h1 {
      font-size: 2em;
      margin: 0.67em 0;
    }
    
    hr {
      box-sizing: content-box; /* 1 */
      height: 0; /* 1 */
      overflow: visible; /* 2 */
    }
    
    pre {
      font-family: monospace, monospace; /* 1 */
      font-size: 1em; /* 2 */
    }
    
    a {
      background-color: transparent;
      text-decoration: none;
    }
    
    abbr[title] {
      border-bottom: none; /* 1 */
      text-decoration: underline; /* 2 */
      text-decoration: underline dotted; /* 2 */
    }
    
    b,
    strong {
      font-weight: bolder;
    }
    
    
    code,
    kbd,
    samp {
      font-family: monospace, monospace; /* 1 */
      font-size: 1em; /* 2 */
    }
    
    
    small {
      font-size: 80%;
    }
    
    sub,
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
    }
    
    sub {
      bottom: -0.25em;
    }
    
    sup {
      top: -0.5em;
    }
    
    img {
      border-style: none;
    }
    
    button,
    input,
    optgroup,
    select,
    textarea {
      font-family: inherit; /* 1 */
      font-size: 100%; /* 1 */
      line-height: 1.15; /* 1 */
      margin: 0; /* 2 */
    }
    
    button,
    input { /* 1 */
      overflow: visible;
    }
    
    button,
    select { /* 1 */
      text-transform: none;
    }
    
    button,
    [type="button"],
    [type="reset"],
    [type="submit"] {
      -webkit-appearance: button;
    }
    
    button::-moz-focus-inner,
    [type="button"]::-moz-focus-inner,
    [type="reset"]::-moz-focus-inner,
    [type="submit"]::-moz-focus-inner {
      border-style: none;
      padding: 0;
    }
    
    button:-moz-focusring,
    [type="button"]:-moz-focusring,
    [type="reset"]:-moz-focusring,
    [type="submit"]:-moz-focusring {
      outline: 1px dotted ButtonText;
    }
    
    fieldset {
      padding: 0.35em 0.75em 0.625em;
    }
    
    legend {
      box-sizing: border-box; /* 1 */
      color: inherit; /* 2 */
      display: table; /* 1 */
      max-width: 100%; /* 1 */
      padding: 0; /* 3 */
      white-space: normal; /* 1 */
    }
    
    progress {
      vertical-align: baseline;
    }
    
    textarea {
      overflow: auto;
    }
    
    [type="checkbox"],
    [type="radio"] {
      box-sizing: border-box; /* 1 */
      padding: 0; /* 2 */
    }
    
    [type="number"]::-webkit-inner-spin-button,
    [type="number"]::-webkit-outer-spin-button {
      height: auto;
    }
    
    [type="search"] {
      -webkit-appearance: textfield; /* 1 */
      outline-offset: -2px; /* 2 */
    }
    
    [type="search"]::-webkit-search-decoration {
      -webkit-appearance: none;
    }
    
    ::-webkit-file-upload-button {
      -webkit-appearance: button; /* 1 */
      font: inherit; /* 2 */
    }
    
    details {
      display: block;
    }
    
    summary {
      display: list-item;
    }
    
    template {
      display: none;
    }
    
    [hidden] {
      display: none;
    }

    .container {
      width: 100%;
      min-width: 62rem;
      max-width: 100rem;
      margin: 0 auto;
      padding: 0 32px;
    }
    .container-fluid {
      width: 100%;
      min-width: 62rem;
      margin: 0 auto;
      padding: 0 32px;
    }
    
    .no-select {
    	-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			-khtml-user-select: none; /* Konqueror HTML */
			-moz-user-select: none; /* Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
			user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
    }
    .not-allowed {
      cursor: not-allowed !important;
    }
    
    .premium-icon{
      color: ${Variables.colors.yellow_500};
      &:last-child{
        margin-right: 8px;
      }
      &:first-child{
        margin-left: 8px;
      }
    }
    
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    
    /* Firefox */
    input[type=number] {
      -moz-appearance:textfield;
    }
    
    .spinner-container {
    	width: 100%;
    	margin: 8px 0;
    	display: flex;
    	justify-content: center;
    	align-items: center;
    }
    .lds-dual-ring {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin: 0 auto;
    }
    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 32px;
        height: 32px;
        margin: 1px;
        border-radius: 50%;
        border: 3px solid #ddd;
        border-color: #ddd transparent #ddd transparent;
        animation: lds-dual-ring 1.4s linear infinite;
        margin:auto;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
		.lds-dual-ring:after {
			content: " ";
			display: block;
			width: 32px;
			height: 32px;
			margin: 1px;
			border-radius: 50%;
			border: 3px solid #ddd;
			border-color: #ddd transparent #ddd transparent;
			animation: lds-dual-ring 1.4s linear infinite;
		}
		@keyframes lds-dual-ring {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}		
		
		.double-bounce2 {
			-webkit-animation-delay: -1.0s;
			animation-delay: -1.0s;
		}
		
		@-webkit-keyframes sk-bounce {
			0%, 100% { -webkit-transform: scale(0.0) }
			50% { -webkit-transform: scale(1.0) }
		}
		
		@keyframes sk-bounce {
			0%, 100% { 
				transform: scale(0.0);
				-webkit-transform: scale(0.0);
			} 50% { 
				transform: scale(1.0);
				-webkit-transform: scale(1.0);
			}
		}
		
		.rials {
			font-size: ${Variables.font_sizes.x_small};
			font-weight: ${Variables.font_weight.regular};
			color: ${Variables.colors.complementary_500};
			margin-right: 8px;
		}
		
		.relative {
			position: relative;
		}
		
		::-ms-clear {
		  display: none;
		}
    .date-time{
      unicode-bidi: plaintext;
    }
`;
